import find from 'lodash/find'
import { FieldOption } from './accountTypes'

const sessionSaleTypes: FieldOption[] = [
  { value: 'fsp', name: 'Faculty Success Program' },
  { value: 'alumni', name: 'Alumni Session' },
  { value: 'writing_challenge', name: '14-Day Writing Challenge' },
  { value: 'generic', name: 'Generic' }
]

export default sessionSaleTypes

export function typeName (value: string): string | null {
  const option = find(sessionSaleTypes, { value })
  return option ? option.name : null
}
